module.exports = __webpack_public_path__ + "static/media/saved.f0cae83f.svg";